module.exports = __webpack_public_path__ + "img/Jump Casting135.c9b2b2b7.jpg";